import React, { Component } from 'react';
import { InformationStyle } from './platformComp';
import request from 'utils/request';
import { getCookie, baiduStatistics, imageUrl, delCookie, setCookie } from 'utils';
import { LoadingOutlined } from '@ant-design/icons';
import { message, Upload, Radio } from 'antd';
import { global } from 'config';

export default class Information extends Component {
    constructor(props) {
        super(props);

        this.state = {
            token: JSON.parse(getCookie('token')),
            imgUrl: '',
            anchor_name: '',
            mobile: '',
            sex_id: '',// 1男，2nv，0保密
            introduction: '',
            wait: 1500, // 节流时间，
            is_request: false, // 请求接口开关
            previous: 0, // 上次的执行时间
        }
    }

    componentDidMount() {
        const { token } = this.state;

        baiduStatistics();

        this.setState({
            imgUrl: token ? imageUrl(token.anchor_data.anchor_icon) : '',
            anchor_name: token ? token.anchor_data.anchor_name : '',
            mobile: token ? token.anchor_data.mobile : '',
            sex_id: token ? +token.anchor_data.sex_id : '',
            introduction: token ? token.anchor_data.introduction : ''
        });
    }

    // 限制图片大小
    beforeUpload = file => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
            message.error('仅支持png/jpg的图片!');
        }
        const isLt2M = file.size / 1024 <= 300;
        if (!isLt2M) {
            message.error('仅支持300k以内的图片!');
        }
        return isJpgOrPng && isLt2M;
    }

    // 上传事件
    sendImage = info => {
        if (info.file.status === 'uploading') {
            return;
        }
        if (info.file.status === 'done') {
            // Get this url from response in real world.
            // console.log(info);
            this.setState({
                imgUrl: imageUrl(info.file.response.msg.file_url),
                image: info.file.response.msg.save_path,
            });
        }
    };

    // 受控组件
    write = key => e => {
        this.setState({
            [key]: e.target.value,
        });
    }

    // 选择性别
    chooseRadio = e => {
        // console.log('radio checked', e.target.value);
        this.setState({
            sex_id: e.target.value,
        });
    };

    cancel = () => {
        window.location.reload();
    }

    // 提交修改
    editProfile = () => {
        const { token, image, anchor_name, wait, is_request, previous, introduction, sex_id } = this.state;

        let now = Date.now(); //获得当前时间戳
        if (now - previous > wait) {
            if (is_request) {
                return;
            }

            this.setState({
                is_request: true
            });

            request({
                url: 'huhuapi/Anchor/modifyManager',
                data: {
                    os: 'pc',
                    sign: token.sign,
                    icon: image,
                    nickname: anchor_name,
                    introduction,
                    sex_id
                }
            }).then(res => {
                // console.log(res.data);
                if (res.data.status) {

                    message.success('修改成功', 1, () => {
                        window.location.reload();
                    });
                    // anchorInfo

                    let obj = {
                        anchor_data: Object.assign({}, token.anchor_data, res.data.data.anchorInfo),
                        sign: token.sign
                    }

                    this.setState({
                        token: obj,
                        previous: now,
                        is_request: false
                    });

                    delCookie('token');
                    setCookie('token', obj);

                } else {
                    this.setState({
                        previous: now,
                        is_request: false
                    });
                    message.error(res.data.errorStr);
                }
            }).catch(err => {
                this.setState({
                    previous: now,
                    is_request: false
                });
                console.log(err)
            });
        }
    }

    render() {
        const { imgUrl, anchor_name, mobile, sex_id, introduction } = this.state;

        return (<InformationStyle>
            <div className="information-kfpt">
                <div className="info-title">基本信息</div>
                <div className="info-icon">
                    <div className="info-t1">您的头像</div>
                    <Upload
                        name="file"
                        listType="picture-card"
                        className="avatar-uploader"
                        showUploadList={false}
                        action={global.domain + "huhuapi/files/upload_image"}
                        beforeUpload={this.beforeUpload}
                        onChange={this.sendImage}
                    >
                        {imgUrl ? <img src={imgUrl} alt="name" style={{ width: '100%' }} /> : <div><LoadingOutlined /></div>}
                    </Upload>
                </div>

                <div className="info-account">
                    <div className="info-t1">您的账号</div>
                    <input value={mobile} className="info-phone" disabled onChange={(e) => this.write('mobile')(e)} />
                </div>

                <div className="info-nick">
                    <div className="info-t1">昵称</div>
                    <input value={anchor_name} className="info-nickname" onChange={(e) => this.write('anchor_name')(e)} />
                </div>

                <div className="info-sex">
                    <div className="info-t1">性别</div>
                    <Radio.Group onChange={this.chooseRadio} value={sex_id}>
                        <Radio value={1}>男</Radio>
                        <Radio value={2}>女</Radio>
                        <Radio value={0}>保密</Radio>
                    </Radio.Group>
                </div>


                <div className="info-intro">
                    <div className="info-t1">简介</div>
                    <textarea className="info-text" maxLength="300" value={introduction} onChange={(e) => this.write('introduction')(e)} placeholder="不超过300字～"></textarea>
                </div>

                <div className="info-btns">
                    <div className="info-btn1" onClick={this.editProfile}>确定</div>
                    <div className="info-btn2" onClick={this.cancel}>取消</div>
                </div>
            </div>
        </InformationStyle >);
    }
}